<template>
  <v-container>

    <v-radio-group v-model="status" row>
      <v-radio label="Todos" value="all"></v-radio>
      <v-radio label="Agendados" value="scheduled"></v-radio>
      <v-radio label="Atendidos" value="attended"></v-radio>
      <v-radio label="Cancelados" value="canceled"></v-radio>
    </v-radio-group>

    <v-container class="pa-0 ma-0">
      <time-line :patientId="user.id" :status="status" v-if="user"/>
    </v-container>
  </v-container>
</template>

<script>
import TimeLine from '@/components/mySchedules/TimeLine';

export default {
  data: () => ({
    status: 'all',
  }),
  computed: {
    user() {
      return this.$store.getters['auth/getUser'];
    },
  },
  components: {
    TimeLine,
  },
};
</script>
